import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiSelect(theme: Theme): MuiThemeComponentOverride<"MuiSelect"> {
  return {
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: theme.palette.brand.blue[100].lighter,
          },
        },
      },
    },
  };
}
